// Widget hrefs come from the backend, so they are treated as untrusted input:
// only a single-leading-slash in-app path ever becomes a link.
//
// Rejecting "//evil.com" (protocol-relative, would navigate off-site) and
// "javascript:..." is the point — a widget author typo shouldn't be able to turn
// a dashboard row into an off-site or script navigation.
export function isInAppPath(href: string | null | undefined): href is string {
  return typeof href === "string" && /^\/(?!\/)/.test(href);
}
